/**
 * Shared helpers for Images & Video email blocks (editor, preview, export).
 */

export function deriveYoutubeThumbnail(url?: string): string | null {
  if (!url) return null;
  try {
    const patterns = [
      /youtu\.be\/([A-Za-z0-9_-]{11})/,
      /youtube\.com\/shorts\/([A-Za-z0-9_-]{11})/,
      /youtube\.com\/watch\?v=([A-Za-z0-9_-]{11})/,
      /youtube\.com\/embed\/([A-Za-z0-9_-]{11})/,
    ];
    for (const pattern of patterns) {
      const match = url.match(pattern);
      if (match?.[1]) {
        return `https://img.youtube.com/vi/${match[1]}/hqdefault.jpg`;
      }
    }
    const urlObj = new URL(url);
    const v = urlObj.searchParams.get('v');
    if (v && v.length === 11) {
      return `https://img.youtube.com/vi/${v}/hqdefault.jpg`;
    }
  } catch {
    return null;
  }
  return null;
}

/** Unified thumbnail field (supports legacy `thumbnail`). */
export function resolveVideoThumbnailUrl(content: {
  thumbnailUrl?: string;
  thumbnail?: string;
  videoUrl?: string;
}): string {
  const manual = (content.thumbnailUrl || content.thumbnail || '').trim();
  if (manual) return manual;
  return deriveYoutubeThumbnail(content.videoUrl) || '';
}

export function resolveImageLinkType(content: {
  linkType?: string;
  linkUrl?: string;
}): string | undefined {
  const url = (content.linkUrl || '').trim();
  if (!url) return undefined;
  const type = (content.linkType || '').trim();
  if (type === 'none') return undefined;
  if (type) return type;
  return 'open-website';
}

export function isSvgStickerContent(stickerType?: string, src?: string): boolean {
  if (!src?.startsWith('<svg')) return false;
  return stickerType === 'builtin' || stickerType === 'badge' || !stickerType;
}

export function videoPlayButtonOverlayHtml(playButtonStyle?: string): string {
  if (playButtonStyle === 'none') return '';
  const borderRadius = playButtonStyle === 'square' ? '8px' : '50%';
  return `
            <div style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 60px; height: 60px; background-color: rgba(0, 0, 0, 0.7); border-radius: ${borderRadius}; border: 2px solid white; display: table;">
              <div style="display: table-cell; vertical-align: middle; text-align: center;">
                <span style="font-size: 0; line-height: 0; border-left: 20px solid #ffffff; border-top: 12px solid transparent; border-bottom: 12px solid transparent; margin-left: 4px; display: inline-block;">&#9658;</span>
              </div>
            </div>`;
}
